
import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

interface CategoryTabsProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  children: React.ReactNode;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({ 
  selectedCategory, 
  onCategoryChange, 
  children 
}) => {
  // Don't render tabs for funding category
  if (selectedCategory === 'funding') {
    return <div className="mt-0">{children}</div>;
  }

  const categories = [
    { id: 'all', label: 'All Reports' },
    { id: 'earnings', label: 'Earnings' },
    { id: 'expenses', label: 'Expenses' },
    { id: 'growth', label: 'Growth' }
  ];

  // Allow funding category to work even though it's not in the visible tabs
  const validCategory = selectedCategory === 'funding' || categories.some(c => c.id === selectedCategory)
    ? selectedCategory
    : 'all';

  return (
    <Tabs 
      defaultValue={validCategory} 
      value={validCategory}
      onValueChange={onCategoryChange}
      className="w-full"
    >
      <TabsList className="w-full bg-gray-100 p-1 mb-6">
        {categories.map(category => (
          <TabsTrigger 
            key={category.id} 
            value={category.id}
            className="flex-1 data-[state=active]:bg-white data-[state=active]:text-redflags-dark"
          >
            {category.label}
          </TabsTrigger>
        ))}
      </TabsList>
      
      <TabsContent value={validCategory} className="mt-0">
        {children}
      </TabsContent>
    </Tabs>
  );
};

export default CategoryTabs;
